import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IList } from '@portal/app/shared/models/IList';

@Component({
  selector: 'portal-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  standalone: false
})
export class ListComponent {
  @Input() public data!: IList[][];
  @Output() public linkClicked = new EventEmitter<IList>();

  public linkClick(item: IList): void {
    this.linkClicked.emit(item);
  }
}
